/**
 * 加号图标
 */
const NodeCompletionIcon = ({
  width = 18,
  height = 18,
  color = 'white',
  fillColor = '#DA291C',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill={color} />
      <path
        d="M4.71094 7.52987L7.06388 9.88281L11.0639 5.88281"
        stroke={fillColor}
        strokeWidth="1.41176"
      />
    </svg>
  )
}

export default NodeCompletionIcon
